import { useState } from "react";
import CreateVerifyOtp from './CreateVerifyOtp';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { verify_Mobile_Number, send_sms } from "../../../Global/Index";
import { FaMobileAlt } from "react-icons/fa";
import { MdEdit } from "react-icons/md";
import Captcha from "./Captcha";
import PropTypes from 'prop-types';
import Location from "../../LoginNew/Location";

const Decisionfun = ({ index, mobileNumber, setIndex, customerLocationDetails }) => {
  if (index === 1) {
    return <CreateVerifyOtp Mobile_Number={mobileNumber} customerLocationDetails={customerLocationDetails} />;
  }
  return null;
};

const Mobile_No = () => {
  const [mobileNumber, setMobileNumber] = useState("");
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isLoadingSendOtp, setIsLoadingSendOtp] = useState(false);
  const [index, setIndex] = useState(10);
  const [customerLocationDetails, setCustomerLocationDetails] = useState({
    longitude: 0.0,
    latitude: 0.0,
    accuracy: 0
  });  // Location is not mandatory for login, uncomment this and location component for enabling it 
  const [rawInput, setRawInput] = useState("");
  const [captchaToken, setCaptchaToken] = useState(null);
  const [isDisabledButton, setIsDisabledButton] = useState(true);

  const handleCaptchaChange = (token) => {
    if (rawInput.length === 10) {
      setCaptchaToken(token);
      setIsDisabledButton(false);
    } else {
      toast.error('Enter your 10-digit mobile number');
    }
  };

  const callme = async () => {
    try {
      await send_sms(mobileNumber);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const verify_mobileNumber = async () => {
    if (mobileNumber.length !== 10) {
      toast.error('Enter your 10-digit mobile number');
      return;
    }

    try {
      if (!captchaToken) {
        toast.error("Please complete the CAPTCHA");
        return;
      }

      // if (!customerLocationDetails) {
      //   toast.error('Please enable location from your browser settings to continue');
      //   return;
      // }

      setIsLoadingSendOtp(true);

      const response = await verify_Mobile_Number(mobileNumber, captchaToken);

      if (response.data.responseCode === '200' || response.data.responseCode === '401') {
        setIsOtpSent(true);
        setIndex(1);
        callme();
        toast.success('OTP sent successfully!');
      } else if (response.data.responseCode === '402') {
        toast.warn('Please enter valid mobile number.');
        setTimeout(() => {
          window.location.reload();
        }, 500);
      }
    } catch (error) {
      console.log(error);
      toast.error('Something went wrong! Please try again later');
    } finally {
      setIsLoadingSendOtp(false);
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value.replace(/\D/g, '');
    setRawInput(value);
    setMobileNumber(value);
    if (value.length === 10 && captchaToken) {
      setIsDisabledButton(false);
    } else {
      setIsDisabledButton(true);
    }
  };


  return (
    <>
      <Location setCustomerLocationDetails={setCustomerLocationDetails} />

      <div style={{
        maxWidth: '440px',
        margin: '12px auto',
        padding: '2rem 1.5rem',
        backgroundColor: '#ffffff',
        borderRadius: '0.75rem',
        boxShadow: '1px 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
      }}>
        <ToastContainer />


        <div style={{ textAlign: 'center', marginBottom: '.5rem' }}>
          <div style={{
            width: '3.5rem',
            height: '3.5rem',
            backgroundColor: '#eff6ff',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 1rem',
            fontSize: '1.75rem',
            color: 'rgb(155, 19, 74)'
          }}>
            <FaMobileAlt />
          </div>
          <h2 style={{
            fontSize: '1.5rem',
            fontWeight: '600',
            color: '#1f2937',
            marginBottom: '0.5rem'
          }}>
            {isOtpSent ? 'Verify OTP' : 'Login to Continue'}
          </h2>
          <p style={{
            fontSize: '0.875rem',
            color: '#6b7280',
            lineHeight: '1.5'
          }}>
            {isOtpSent ? 'Enter the code sent to your mobile number' : 'Enter your mobile number to receive OTP'}
          </p>
        </div>

        {/* Mobile Number Input Section - Show only when OTP not sent */}
        {!isOtpSent && (
          <>
            {/* Mobile Input */}
            <div style={{ marginBottom: '.5rem' }}>

              <div style={{
                display: 'flex',
                alignItems: 'center',
                border: '1px solid #d1d5db',
                borderRadius: '0.2rem',
                overflow: 'hidden',
                transition: 'all 0.2s',
                backgroundColor: '#ffffff',
                width: '100%',
                maxWidth: '276px',
                minWidth: '276px',
                margin: 'auto'
              }}
                onFocus={(e) => e.currentTarget.style.borderColor = 'rgb(155, 19, 74)'}
                onBlur={(e) => e.currentTarget.style.borderColor = '#d1d5db'}
              >
                <div style={{
                  padding: '0 1rem',
                  backgroundColor: '#f9fafb',
                  borderRight: '1px solid #d1d5db',
                  height: '3rem',
                  display: 'flex',
                  alignItems: 'center',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#374151'
                }}>
                  +91
                </div>
                <input
                  type="tel"
                  placeholder="Enter 10-digit mobile number"
                  onChange={handleInputChange}
                  value={rawInput}
                  maxLength={10}
                  pattern="[0-9]*"
                  inputMode="numeric"
                  style={{
                    flex: 1,
                    padding: '0 1rem',
                    fontSize: '14px',
                    height: '3rem',
                    border: 'none',
                    outline: 'none',
                    color: '#1f2937',
                    fontWeight: '500'
                  }}
                />
              </div>
            </div>


            <Captcha onCaptchaChange={handleCaptchaChange} />



            <p style={{
              fontSize: '0.75rem',
              color: '#6b7280',
              textAlign: 'center',
              marginBottom: '1rem',
              lineHeight: '1.5'
            }}>
              By continuing, you agree to our{' '}
              <a
                href="https://www.indiashelter.in/privacypolicy"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: '#3b82f6',
                  textDecoration: 'none',
                  fontWeight: '500'
                }}
                onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
              >
                Privacy Policy
              </a>
              {' '}and{' '}
              <a
                href="https://www.indiashelter.in/terms"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: '#3b82f6',
                  textDecoration: 'none',
                  fontWeight: '500'
                }}
                onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
              >
                Terms of Use
              </a>
            </p>

            {/* Get OTP Button */}
            <button
              onClick={verify_mobileNumber}
              disabled={isDisabledButton || isLoadingSendOtp}
              style={{
                padding: '0.7rem',
                fontSize: '16px',
                fontWeight: '600',
                color: '#ffffff',
                background: isDisabledButton || isLoadingSendOtp
                  ? '#d1d5db'
                  : 'linear-gradient(to right, rgb(155, 19, 74), rgb(185, 80, 71))',
                border: 'none',
                borderRadius: '18rem',
                cursor: isDisabledButton || isLoadingSendOtp ? 'not-allowed' : 'pointer',
                transition: 'all 0.2s',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.5rem',
                opacity: isDisabledButton || isLoadingSendOtp ? 0.6 : 1,
                width: '100%',
                maxWidth: '250px',
                minWidth: '250px',
                margin: 'auto'
              }}
              onMouseEnter={(e) => {
                if (!isDisabledButton && !isLoadingSendOtp) {
                  e.target.style.transform = 'translateY(-1px)';
                  e.target.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)';
                }
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = 'none';
              }}
            >
              {isLoadingSendOtp ? (
                <>
                  <div style={{
                    width: '1rem',
                    height: '1rem',
                    border: '2px solid #ffffff',
                    borderTopColor: 'transparent',
                    borderRadius: '50%',
                    animation: 'spin 0.8s linear infinite'
                  }} />
                  <span>Sending OTP...</span>
                </>
              ) : (
                'GET OTP'
              )}
            </button>
          </>
        )}

        {/* OTP Section - Showing only when OTP sent */}
        {isOtpSent && (
          <>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.75rem',
              marginBottom: '1.5rem',
              padding: '0.75rem 1rem',
              backgroundColor: '#f9fafb',
              borderRadius: '0.5rem',
              border: '1px solid #e5e7eb',
              width: '91%',
              margin: '2vh auto'

            }}>
              <span style={{
                fontSize: '0.9375rem',
                fontWeight: '600',
                color: '#374151'
              }}>
                +91 XXXXXXXX{mobileNumber.slice(-2)}
              </span>

            </div>

            {/* OTP Component */}
            {customerLocationDetails && (
              <Decisionfun
                index={index}
                mobileNumber={mobileNumber}
                setIndex={setIndex}
                customerLocationDetails={customerLocationDetails}
              />
            )}
          </>
        )}

        <style>{`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    </>
  );
};

Decisionfun.propTypes = {
  index: PropTypes.number.isRequired,
  mobileNumber: PropTypes.string.isRequired,
  setIndex: PropTypes.func.isRequired,
  // customerLocationDetails: PropTypes.object
};

export default Mobile_No;